export const brand = {
  blue: '#0099D8',
  blueDark: '#002E61',
  blueLight: '#B8DCED',
  blueMid: '#2C5875',
  green: '#006A52',
  greenBright: '#2ECC8F',
  greenDeep: '#0B2A1F',
  orange: '#E35205',
  red: '#C62828',
  redBright: '#FF6B6B',
  redDeep: '#2E0B0B',
} as const;

export const sidebar = {
  background: '#1C2B39',
  hover: '#24384A',
  textDim: '#B8DCED',
} as const;

export const lightNeutrals = {
  background: '#F5F7F8',
  border: '#DDE3E6',
  borderStrong: '#C7CFD3',
  surface: '#FFFFFF',
  surfaceMuted: '#EEF1F2',
  text: '#1C2B39',
  textDim: '#475259',
  textFaint: '#7C8791',
} as const;

export const darkNeutrals = {
  background: '#101C26',
  border: '#2C3F4E',
  borderStrong: '#3C5164',
  surface: '#18262F',
  surfaceMuted: '#1F303B',
  text: '#EAF2F6',
  textDim: '#B8C4CC',
  textFaint: '#8493A0',
} as const;

export const darkContrastBrand = {
  blue: '#82D4FF',
  blueMid: '#4DB6FF',
  cyan: '#00D7FF',
  cyanBright: '#00FFC6',
  green: '#39FF14',
  greenEmer: '#2EE59D',
  greenSoft: '#52FF3A',
  red: '#FF4D6D',
} as const;

export const darkContrastNeutrals = {
  background: '#0F1419',
  border: '#1E3A4A',
  borderStrong: '#1C4D63',
  surface: '#0B1116',
  surfaceMuted: '#0D1B24',
  text: '#C7D6E0',
  textDim: '#6B7C8A',
  textFaint: '#3E5563',
} as const;

export const fontFamily = "'Poppins', sans-serif";
